import { CatClient } from 'ccat-api';
import { marked } from 'marked';
import markedKatex from 'marked-katex-extension';
import renderMathInElement from 'katex/contrib/auto-render';
// Importa Bootstrap
import * as bootstrap from 'bootstrap';

marked.use((markedKatex.default || markedKatex)({
    throwOnError: false,
    nonStandard: true
}));

document.addEventListener('DOMContentLoaded', () => {
    if (!document.getElementById('btnSend')) {
        return;
    }

    console.log('Chat: Init');
    
    let catIsConnected = false;
    const messageInput = document.getElementById('msgInput');
    const sendButton = document.getElementById('btnSend');
    const dictateButton = document.getElementById('btnDictate');
    const pdfInput = document.getElementById('pdfInput');
    const pdfUploadButton = document.getElementById('btnPdfUpload');
    const pdfStatus = document.getElementById('pdfStatus');
    const attachmentsPreview = document.getElementById('chatAttachmentsPreview');
    const chatContainer = document.getElementById('chat-content-messages');
    const statusDiv = document.getElementById('status');
    const userID = document.getElementById('userId').value;
    const chatIdInput = document.getElementById('chatId');
    const catUserIdInput = document.getElementById('catUserId');
    const chatPdfFilenameInput = document.getElementById('chatPdfFilename');
    let currentChatId = chatIdInput.value || '';
    if (currentChatId === 'null' || currentChatId === 'undefined') {
        currentChatId = '';
    }
    let currentCatUserId = catUserIdInput.value || `agora_user_${userID}`;
    let currentPdfFilename = chatPdfFilenameInput.value || '';
    if (currentPdfFilename === 'null' || currentPdfFilename === 'undefined') {
        currentPdfFilename = '';
    }
    let currentAttachments = [];
    try {
        const parsed = JSON.parse(currentPdfFilename);
        if (Array.isArray(parsed)) {
            currentAttachments = parsed;
        } else if (parsed) {
            currentAttachments = [parsed];
        }
    } catch (e) {
        if (currentPdfFilename) {
            currentAttachments = [currentPdfFilename];
        }
    }
    let currentAiMessageDiv = null;
    let accumulatedAiMarkdown = "";
    let loaderDiv = null;
    let recognition = null;
    let isDictating = false;
    let streamingRenderScheduled = false;

    let pendingPdfContext = '';
    let dictationBaseText = '';
    let microphonePermissionGranted = false;
    const maxPdfSize = 10 * 1024 * 1024;
    const pdfDisclaimer = 'Attenzione: non caricare documenti con dati personali, sensibili o riservati.';

    // Helper per headers API coerenti (inclusa autenticazione e Accept JSON)
    function getApiHeaders(isJson = true) {
        const headers = {
            'Accept': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || ''
        };
        if (isJson) {
            headers['Content-Type'] = 'application/json';
        }
        const apiTokenMeta = document.querySelector('meta[name="api_token"]');
        if (apiTokenMeta && apiTokenMeta.content && apiTokenMeta.content.trim() !== '') {
            headers['Authorization'] = 'Bearer ' + apiTokenMeta.content.trim();
        }
        return headers;
    }

    // Helper per parsing JSON sicuro evitando eccezioni di pattern su Safari
    async function safeParseJson(response) {
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
            return await response.json();
        }
        const text = await response.text();
        throw new Error(text && text.length < 200 ? text : `Errore risposta server (${response.status})`);
    }

    // Mantieni riferimenti alle modal per evitare problemi
    let renameModal = null;
    let deleteModal = null;
    
    // Funzione per ottenere il prefisso del percorso corrente
    function getRoutePrefix() {
        const path = window.location.pathname;
        if (path.startsWith('/auth/')) {
            return '/auth';
        }
        return '';
    }
    const cat = new CatClient({
        host: 'chat.agoratecnica.it',
        userId: currentCatUserId,
        secure: true,
        port: 443
    });

    // Inizializza la chat
    initializeChat();

    function initializeChat() {
        renderMathInChat();
        setupEventListeners();
        loadSuggestions();
        initializeModals();
        checkForInitialMessage();
        initAutoResizeTextarea();
        renderAttachmentsPreview();
        setPdfControlsEnabled(true); // Abilita i controlli del documento all'inizializzazione
    }

    function renderMathInChat(targetElement = null) {
        const el = targetElement || chatContainer;
        if (!el) return;
        try {
            renderMathInElement(el, {
                delimiters: [
                    { left: '$$', right: '$$', display: true },
                    { left: '$', right: '$', display: false }
                ],
                throwOnError: false
            });
        } catch (e) {
            console.error('KaTeX auto-render error:', e);
        }
    }

    function initAutoResizeTextarea() {
        if (!messageInput) return;
        adjustTextareaHeight();
        messageInput.addEventListener('input', adjustTextareaHeight);
    }

    function adjustTextareaHeight() {
        if (!messageInput) return;
        messageInput.style.height = 'auto';
        const maxHeight = 180;
        const newHeight = Math.min(messageInput.scrollHeight, maxHeight);
        messageInput.style.height = `${Math.max(newHeight, 56)}px`;
    }
    function checkForInitialMessage() {
        // Controlla se c'è un messaggio iniziale nei parametri URL
        const urlParams = new URLSearchParams(window.location.search);
        const initialMessage = urlParams.get('msg');
        
        if (initialMessage) {
            let decodedMessage = initialMessage;
            try {
                decodedMessage = decodeURIComponent(initialMessage);
            } catch (e) {
                decodedMessage = initialMessage;
            }

            if (currentChatId) {
                // Rimuovi il parametro dall'URL senza ricaricare la pagina
                const newUrl = window.location.pathname;
                history.replaceState({}, document.title, newUrl);
                
                // Imposta il messaggio nell'input e invialo automaticamente
                messageInput.value = decodedMessage;
                adjustTextareaHeight();
                
                // Aspetta che la connessione sia stabilita prima di inviare
                const checkConnection = setInterval(() => {
                    if (catIsConnected) {
                        sendMessage();
                        clearInterval(checkConnection);
                    }
                }, 100);
            } else {
                // Se non c'è una chat attiva, creala automaticamente
                createNewChat(decodedMessage);
            }
        }
    }

    function initializeModals() {
        // Inizializza le modal una volta sola
        const renameModalElement = document.getElementById('renameChatModal');
        const deleteModalElement = document.getElementById('deleteChatModal');
        
        if (renameModalElement) {
            renameModal = new bootstrap.Modal(renameModalElement);
        }
        
        if (deleteModalElement) {
            deleteModal = new bootstrap.Modal(deleteModalElement);
        }
    }

    function setupEventListeners() {
        // Evento per inviare messaggi
        sendButton.addEventListener('click', sendMessage);

        // Enter invia il messaggio, Shift+Enter inserisce una nuova riga
        messageInput.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault();
                sendMessage();
            }
        });

        if (pdfUploadButton && pdfInput) {
            pdfUploadButton.addEventListener('click', () => {
                if (pdfUploadButton.disabled) {
                    return;
                }

                pdfInput.click();
            });
            pdfInput.addEventListener('change', uploadPdf);
        }

        setupDictation();

        // Evento per creare nuova chat
        document.getElementById('btnNewChat').addEventListener('click', () => {
            const currentMessage = messageInput.value.trim();
            createNewChat(currentMessage || null);
        });

        // Eventi per rinominare chat
        document.addEventListener('click', (e) => {
            if (e.target.closest('.btn-edit-chat')) {
                const btn = e.target.closest('.btn-edit-chat');
                const chatId = btn.dataset.chatId;
                const chatName = btn.dataset.chatName;
                openRenameModal(chatId, chatName);
            }
        });

        // Eventi per eliminare chat  
        document.addEventListener('click', (e) => {
            if (e.target.closest('.btn-delete-chat')) {
                const btn = e.target.closest('.btn-delete-chat');
                const chatId = btn.dataset.chatId;
                openDeleteModal(chatId);
            }
        });

        // Salvataggio nuovo nome
        document.getElementById('saveNewName').addEventListener('click', saveNewChatName);
        
        // Conferma eliminazione
        document.getElementById('confirmDelete').addEventListener('click', confirmDeleteChat);

        // Eventi per i suggerimenti
        document.addEventListener('click', (e) => {
            if (e.target.closest('.suggestion-item')) {
                const suggestion = e.target.closest('.suggestion-item').textContent.trim();
                useSuggestion(suggestion);
            }
        });
    }

    async function loadSuggestions() {
        const container = document.getElementById('suggestions-container');
        if (!container) {
            return;
        }

        try {
            const response = await fetch(`/api/chat/chat-suggestions`, {
                method: 'GET',
                headers: getApiHeaders(true),
            });

            const data = await safeParseJson(response);

            if (data.success) {
                displaySuggestions(data.suggestions);
                return;
            }
        } catch (error) {
            console.error('Errore nel caricamento dei suggerimenti:', error);
        }

        displaySuggestions([
            "Progettazione di una pista ciclabile in Friuli venezia giulia",
            "Normativa di riferimento per la prevenzione incendi di un capannone industriale",
            "Normativa regionale in Lombardia relativa al permesso di costruire in zona agricola"
        ]);
    }

    function displaySuggestions(suggestions) {
        const container = document.getElementById('suggestions-container');
        if (container) {
            container.innerHTML = suggestions.map(suggestion => 
                `<div class="suggestion-item">${suggestion}</div>`
            ).join('');
        }
    }

    async function useSuggestion(suggestion) {
        // Se non c'è una chat attiva, creane una nuova con il suggerimento come messaggio iniziale
        if (!currentChatId) {
            await createNewChat(suggestion);
            return;
        }
        
        // Imposta il testo del suggerimento nell'input e invia
        messageInput.value = suggestion;
        adjustTextareaHeight();
        sendMessage();
    }

    async function createNewChat(initialMessage = null) {
        try {
            const response = await fetch('/api/chat/chats', {
                method: 'POST',
                headers: getApiHeaders(true),
                body: JSON.stringify({
                    name: `Nuova Chat - ${new Date().toLocaleDateString()}`
                })
            });

            const data = await safeParseJson(response);
            
            if (data.success) {
                // Reindirizza alla nuova chat mantenendo il prefisso del percorso corrente
                const prefix = getRoutePrefix();
                let redirectUrl = `${prefix}/chat/${data.chat.id}`;
                
                // Se c'è un messaggio iniziale, aggiungilo come parametro URL
                if (initialMessage) {
                    redirectUrl += `?msg=${encodeURIComponent(initialMessage)}`;
                }
                
                window.location.href = redirectUrl;
            } else {
                alert('Errore nella creazione della chat');
            }
        } catch (error) {
            console.error('Errore nella creazione della chat:', error);
            alert('Errore nella creazione della chat');
        }
    }

    function openRenameModal(chatId, currentName) {
        document.getElementById('editingChatId').value = chatId;
        document.getElementById('chatNewName').value = currentName;
        
        if (renameModal) {
            renameModal.show();
        }
    }

    async function saveNewChatName() {
        const chatId = document.getElementById('editingChatId').value;
        const newName = document.getElementById('chatNewName').value.trim();
        
        if (!newName) {
            alert('Il nome della chat non può essere vuoto');
            return;
        }

        try {
            const response = await fetch(`/api/chat/chats/${chatId}`, {
                method: 'PUT',
                headers: getApiHeaders(true),
                body: JSON.stringify({ name: newName })
            });

            const data = await safeParseJson(response);
            
            if (data.success) {
                // Aggiorna il nome nella sidebar
                const chatItem = document.querySelector(`[data-chat-id="${chatId}"]`);
                if (chatItem) {
                    chatItem.querySelector('.chat-name').textContent = newName;
                    chatItem.querySelector('.btn-edit-chat').dataset.chatName = newName;
                }
                
                // Nascondi il modal
                if (renameModal) {
                    renameModal.hide();
                }
            } else {
                alert('Errore nel rinominare la chat');
            }
        } catch (error) {
            console.error('Errore nel rinominare la chat:', error);
            alert('Errore nel rinominare la chat');
        }
    }

    function openDeleteModal(chatId) {
        document.getElementById('deletingChatId').value = chatId;
        
        if (deleteModal) {
            deleteModal.show();
        }
    }

    async function confirmDeleteChat() {
        const chatId = document.getElementById('deletingChatId').value;
        
        try {
            const response = await fetch(`/api/chat/chats/${chatId}`, {
                method: 'DELETE',
                headers: getApiHeaders(true)
            });

            const data = await safeParseJson(response);
            
            if (data.success) {
                // Se stiamo eliminando la chat corrente, reindirizza alla pagina principale
                if (chatId == currentChatId) {
                    const prefix = getRoutePrefix();
                    window.location.href = `${prefix}/chat`;
                } else {
                    // Rimuovi l'elemento dalla sidebar
                    const chatItem = document.querySelector(`[data-chat-id="${chatId}"]`);
                    if (chatItem) chatItem.remove();
                }
                
                // Nascondi il modal
                if (deleteModal) {
                    deleteModal.hide();
                }
            } else {
                alert('Errore nell\'eliminazione della chat');
            }
        } catch (error) {
            console.error('Errore nell\'eliminazione della chat:', error);
            alert('Errore nell\'eliminazione della chat');
        }
    }

    async function saveMessageToDatabase(role, content) {
        if (!currentChatId) return;
        
        try {
            await fetch(`/api/chat/chats/${currentChatId}/messages`, {
                method: 'POST',
                headers: getApiHeaders(true),
                body: JSON.stringify({
                    role: role,
                    content: content
                })
            });
        } catch (error) {
            console.error('Errore nel salvare il messaggio:', error);
        }
    }
    async function createNewChatSilently() {
        const response = await fetch('/api/chat/chats', {
            method: 'POST',
            headers: getApiHeaders(true),
            body: JSON.stringify({
                name: `Nuova Chat - ${new Date().toLocaleDateString()}`
            })
        });

        const data = await safeParseJson(response);
        if (response.ok && data.success) {
            return data.chat;
        }
        throw new Error('Errore nella creazione della chat');
    }

    function renderAttachmentsPreview() {
        if (!attachmentsPreview) return;
        attachmentsPreview.innerHTML = '';

        if (!currentAttachments || currentAttachments.length === 0) {
            attachmentsPreview.style.display = 'none';
            return;
        }

        attachmentsPreview.style.display = 'flex';
        currentAttachments.forEach(filename => {
            const chip = document.createElement('div');
            chip.className = 'chat-attachment-chip';
            chip.dataset.filename = filename;
            chip.innerHTML = `
                <i class="fas fa-file-alt text-primary"></i>
                <span class="chip-name" title="${escapeHtml(filename)}">${escapeHtml(filename)}</span>
                <button type="button" class="chip-remove" title="Rimuovi" data-filename="${escapeHtml(filename)}">
                    <i class="fas fa-times"></i>
                </button>
            `;
            chip.querySelector('.chip-remove').addEventListener('click', (e) => {
                e.stopPropagation();
                removeAttachment(filename);
            });
            attachmentsPreview.appendChild(chip);
        });
    }

    async function removeAttachment(filename) {
        if (!currentChatId) {
            currentAttachments = currentAttachments.filter(f => f !== filename);
            chatPdfFilenameInput.value = JSON.stringify(currentAttachments);
            pendingPdfContext = '';
            renderAttachmentsPreview();
            return;
        }

        try {
            const response = await fetch(`/api/chat/chats/${currentChatId}/pdf?filename=${encodeURIComponent(filename)}`, {
                method: 'DELETE',
                headers: getApiHeaders(true)
            });
            const data = await safeParseJson(response);
            if (data.success) {
                currentAttachments = data.filenames || currentAttachments.filter(f => f !== filename);
                chatPdfFilenameInput.value = JSON.stringify(currentAttachments);
                pendingPdfContext = '';
                renderAttachmentsPreview();
            } else {
                alert(data.message || 'Errore nella rimozione del documento');
            }
        } catch (error) {
            console.error('Errore nella rimozione del documento:', error);
            alert(error.message || 'Errore nella rimozione del documento');
        }
    }

    async function uploadPdf() {
        const files = Array.from(pdfInput.files || []);
        if (files.length === 0) {
            return;
        }

        const maxFileSize = 10 * 1024 * 1024;
        const allowedExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt'];

        for (const file of files) {
            const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            if (!allowedExtensions.includes(fileExtension)) {
                alert(`Il file "${file.name}" non è in un formato consentito. Formati ammessi: PDF, DOC, DOCX, XLS, XLSX, TXT.`);
                pdfInput.value = '';
                return;
            }
            if (file.size > maxFileSize) {
                alert(`Il file "${file.name}" supera la dimensione massima di 10 MB.`);
                pdfInput.value = '';
                return;
            }
        }

        let uploadChatId = currentChatId;
        let isNewChat = false;

        if (!uploadChatId) {
            isNewChat = true;
            setPdfUploading(true);
            try {
                const newChat = await createNewChatSilently();
                uploadChatId = newChat.id;
                currentChatId = uploadChatId;
                chatIdInput.value = uploadChatId;
            } catch (error) {
                console.error('Errore creazione chat silente:', error);
                alert('Errore nella creazione della chat');
                setPdfUploading(false);
                pdfInput.value = '';
                return;
            }
        }

        // Mostra chip di caricamento temporanei
        if (attachmentsPreview) {
            attachmentsPreview.style.display = 'flex';
            files.forEach(file => {
                const loadingChip = document.createElement('div');
                loadingChip.className = 'chat-attachment-chip chip-uploading temp-loading-chip';
                loadingChip.innerHTML = `
                    <i class="fas fa-spinner fa-spin text-primary"></i>
                    <span class="chip-name">${escapeHtml(file.name)}</span>
                `;
                attachmentsPreview.appendChild(loadingChip);
            });
        }

        const formData = new FormData();
        files.forEach(file => {
            formData.append('files[]', file);
        });
        if (files.length === 1) {
            formData.append('pdf', files[0]);
        }

        setPdfUploading(true);

        try {
            const response = await fetch(`/api/chat/chats/${uploadChatId}/pdf`, {
                method: 'POST',
                headers: getApiHeaders(false),
                body: formData
            });

            const data = await safeParseJson(response);

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Errore nel caricamento del documento');
            }

            if (data.filenames && Array.isArray(data.filenames)) {
                currentAttachments = data.filenames;
            } else if (data.filename) {
                if (!currentAttachments.includes(data.filename)) {
                    currentAttachments.push(data.filename);
                }
            }
            chatPdfFilenameInput.value = JSON.stringify(currentAttachments);
            pendingPdfContext = data.pdf_context || '';

            renderAttachmentsPreview();

            if (isNewChat) {
                const prefix = getRoutePrefix();
                window.location.href = `${prefix}/chat/${uploadChatId}`;
            }
        } catch (error) {
            console.error('Errore nel caricamento del documento:', error);
            alert(error.message || 'Errore nel caricamento del documento');
            renderAttachmentsPreview();
        } finally {
            setPdfUploading(false);
            pdfInput.value = '';
        }
    }

    function setPdfStatus(message, isError = false) {
        if (!pdfStatus) return;

        pdfStatus.textContent = message || '';
        pdfStatus.classList.toggle('chat-file-status-error', isError);
    }

    function setPdfUploading(isUploading) {
        if (pdfUploadButton) {
            pdfUploadButton.disabled = isUploading;
            pdfUploadButton.title = isUploading ? 'Caricamento in corso...' : 'Carica Documento';
            const icon = pdfUploadButton.querySelector('i');
            if (icon) {
                icon.className = isUploading ? 'fas fa-spinner fa-spin' : 'fas fa-paperclip';
            }
        }
    }

    function setPdfControlsEnabled(isEnabled) {
        if (pdfInput) {
            pdfInput.disabled = !isEnabled;
        }

        if (pdfUploadButton) {
            pdfUploadButton.disabled = !isEnabled;
            pdfUploadButton.title = 'Carica Documento';
        }
    }

    function setupDictation() {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

        if (!dictateButton) {
            return;
        }

        if (!SpeechRecognition) {
            dictateButton.disabled = false;
            dictateButton.title = 'Dettatura non supportata dal browser';
            dictateButton.addEventListener('click', async () => {
                await requestMicrophonePermission();
                alert('La dettatura non è supportata da questo browser. Usa Chrome, Edge o Safari aggiornati.');
            });
            return;
        }

        recognition = new SpeechRecognition();
        recognition.lang = 'it-IT';
        recognition.continuous = false;
        recognition.interimResults = true;

        dictateButton.addEventListener('click', toggleDictation);

        recognition.onstart = () => {
            isDictating = true;
            dictationBaseText = messageInput.value;
            dictateButton.classList.add('is-recording');
            dictateButton.title = 'Interrompi dettatura';
        };

        recognition.onend = () => {
            isDictating = false;
            dictateButton.classList.remove('is-recording');
            dictateButton.title = 'Detta messaggio';
            adjustTextareaHeight();
        };

        recognition.onerror = (event) => {
            console.error('Errore nella dettatura:', event.error);
            isDictating = false;
            dictateButton.classList.remove('is-recording');

            if (event.error === 'not-allowed' || event.error === 'service-not-allowed') {
                alert('Per usare la dettatura devi consentire l\'accesso al microfono nel browser.');
            } else if (event.error === 'no-speech') {
                alert('Non ho rilevato voce. Riprova parlando dopo aver attivato il microfono.');
            } else {
                alert('La dettatura non è stata avviata. Verifica i permessi del microfono e il browser utilizzato.');
            }
        };

        recognition.onresult = (event) => {
            let finalTranscript = '';
            let interimTranscript = '';

            for (let i = event.resultIndex; i < event.results.length; i++) {
                if (event.results[i].isFinal) {
                    finalTranscript += event.results[i][0].transcript;
                } else {
                    interimTranscript += event.results[i][0].transcript;
                }
            }

            const transcript = `${finalTranscript} ${interimTranscript}`.trim();

            if (transcript) {
                const separator = dictationBaseText.trim() ? ' ' : '';
                messageInput.value = `${dictationBaseText}${separator}${transcript}`.trim();
                adjustTextareaHeight();
            }

            if (finalTranscript) {
                dictationBaseText = messageInput.value;
            }

            messageInput.focus();
        };
    }

    async function requestMicrophonePermission() {
        if (microphonePermissionGranted) {
            return true;
        }

        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            alert('Il browser non permette di richiedere i permessi del microfono da questa pagina.');
            return false;
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            stream.getTracks().forEach((track) => track.stop());
            microphonePermissionGranted = true;
            return true;
        } catch (error) {
            console.error('Permesso microfono non concesso:', error);
            alert('Per usare la dettatura devi consentire l\'accesso al microfono nel browser.');
            return false;
        }
    }

    async function toggleDictation() {
        if (!recognition) {
            return;
        }

        if (isDictating) {
            recognition.stop();
        } else {
            const hasMicrophonePermission = await requestMicrophonePermission();

            if (!hasMicrophonePermission) {
                return;
            }

            try {
                messageInput.focus();
                recognition.start();
            } catch (error) {
                console.error('Errore nell\'avvio della dettatura:', error);
            }
        }
    }

    function createMessageElement(senderId) {
        const messageElement = document.createElement('div');
        messageElement.classList.add('chat-content-messages-message');
        if (senderId === userID) {
            messageElement.classList.add('chat-content-messages-message-user');
        } else {
            messageElement.classList.add('chat-content-messages-message-bot');
        }
        chatContainer.appendChild(messageElement);
        
        // Nascondi i suggerimenti se sono visibili
        const suggestions = document.getElementById('chat-suggestions');
        if (suggestions) {
            suggestions.style.display = 'none';
        }
        
        return messageElement;
    }

    function showLoader() {
        if (loaderDiv) return;
        
        loaderDiv = createMessageElement('AI');
        loaderDiv.classList.add('loading-message');
        loaderDiv.innerHTML = `
            <div class="loader-container">
                <div class="typing-indicator">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <span class="loading-text">L'AI sta scrivendo...</span>
            </div>
        `;
        chatContainer.scrollTop = chatContainer.scrollHeight;
    }

    function hideLoader() {
        if (loaderDiv) {
            loaderDiv.remove();
            loaderDiv = null;
        }
    }

    function getFileIconClass(filename) {
        const ext = (filename.split('.').pop() || '').toLowerCase();
        switch (ext) {
            case 'pdf': return 'fa-file-pdf';
            case 'doc':
            case 'docx': return 'fa-file-word';
            case 'xls':
            case 'xlsx': return 'fa-file-excel';
            case 'txt': return 'fa-file-alt';
            default: return 'fa-paperclip';
        }
    }

    function createAttachmentsMarkup(attachmentNames) {
        if (!attachmentNames) return '';
        const list = Array.isArray(attachmentNames)
            ? attachmentNames
            : attachmentNames.split(',').map(s => s.trim()).filter(Boolean);
        if (list.length === 0) return '';

        return `<div class="chat-message-attachments">${list.map(fn => `
            <div class="chat-message-attachment" title="${escapeHtml(fn)}">
                <i class="fas ${getFileIconClass(fn)}"></i>
                <span class="attachment-name">${escapeHtml(fn)}</span>
            </div>
        `).join('')}</div>`;
    }

    function displayMessage(markdownMessage, senderId, attachmentName = null) {
        const messageElement = createMessageElement(senderId);
        const attachmentMarkup = createAttachmentsMarkup(attachmentName);

        messageElement.innerHTML = `${attachmentMarkup}${marked.parse(markdownMessage || "")}`;
        renderMathInChat(messageElement);
        chatContainer.scrollTop = chatContainer.scrollHeight;
    }

    function escapeHtml(value) {
        const element = document.createElement('div');
        element.textContent = value || '';
        return element.innerHTML;
    }

    async function sendMessage() {
        const messageText = messageInput.value.trim();
        if (messageText && !currentChatId) {
            await createNewChat(messageText);
            return;
        }

        if (messageText && catIsConnected) {
            messageInput.value = '';
            adjustTextareaHeight();
            await sendTextToCat(messageText);
        }
    }

    async function sendTextToCat(messageText, persist = true) {
        if (messageText && catIsConnected) {
            console.log("Invio messaggio:", messageText);
            const pdfContext = await getPdfContext();
            const messageForCat = pdfContext
                ? `${pdfContext}\n\nRichiesta dell'utente:\n${messageText}`
                : messageText;

            const docLabel = currentAttachments && currentAttachments.length > 0
                ? currentAttachments.join(', ')
                : null;

            const persistedMessage = docLabel
                ? (currentAttachments.length === 1
                    ? `[Documento allegato: ${docLabel}]\n\n${messageText}`
                    : `[Documenti allegati: ${docLabel}]\n\n${messageText}`)
                : messageText;

            if (persist) {
                await saveMessageToDatabase('user', persistedMessage);
            }

            cat.send({text: messageForCat});
            displayMessage(messageText, userID, docLabel);

            showLoader();
        }
    }

    async function getPdfContext() {
        if (pendingPdfContext) {
            return pendingPdfContext;
        }

        if (!currentChatId || !currentAttachments || currentAttachments.length === 0) {
            return '';
        }

        try {
            const response = await fetch(`/api/chat/chats/${currentChatId}/pdf-context`, {
                method: 'GET',
                headers: getApiHeaders(true),
            });

            const data = await safeParseJson(response);

            if (response.ok && data.success) {
                pendingPdfContext = data.pdf_context || '';
                return pendingPdfContext;
            }
        } catch (error) {
            console.error('Errore nel recuperare il contesto PDF:', error);
        }

        return '';
    }


    function scheduleStreamingRender() {
        if (streamingRenderScheduled) return;
        streamingRenderScheduled = true;

        requestAnimationFrame(() => {
            streamingRenderScheduled = false;
            if (currentAiMessageDiv) {
                currentAiMessageDiv.innerHTML = marked.parse(accumulatedAiMarkdown || "");
                renderMathInChat(currentAiMessageDiv);

                const distanceFromBottom = chatContainer.scrollHeight - chatContainer.scrollTop - chatContainer.clientHeight;
                if (distanceFromBottom < 160) {
                    chatContainer.scrollTop = chatContainer.scrollHeight;
                }
            }
        });
    }

    function updateConnectionStatus(isConnected, message) {
        catIsConnected = isConnected;
        messageInput.disabled = false;
        sendButton.disabled = !!currentChatId && !isConnected;
        if (dictateButton && recognition) {
            dictateButton.disabled = false;
        }
        setPdfControlsEnabled(true);
    }

    cat.onConnected(() => {
        updateConnectionStatus(true, 'Connesso');
        console.log('Chat: Socket connected');
    }).onError((err, e) => {
        updateConnectionStatus(false, `Errore di connessione: ${err.message || err}`);
        console.error(err, e);
        hideLoader();
    }).onDisconnected(() => {
        updateConnectionStatus(false, 'Disconnesso. Tentativo di riconnessione...');
        console.log('Chat: Socket disconnected');
        hideLoader();
    });

    cat.onMessage(async (data) => {
        console.log('Chat: Raw message received:', data);
        
        if (data && data.type === "chat_token" && data.content !== undefined) {
            const tokenContent = data.content;
            hideLoader();

            if (!currentAiMessageDiv) {
                currentAiMessageDiv = createMessageElement('AI');
                chatContainer.appendChild(currentAiMessageDiv);
                accumulatedAiMarkdown = "";
            }

            accumulatedAiMarkdown += tokenContent;
            scheduleStreamingRender();

        } else if (data && data.who === 'AI' && data.text !== undefined) {
            const messageContent = data.text;
            hideLoader();

            if (currentAiMessageDiv) {
                currentAiMessageDiv.innerHTML = marked.parse(messageContent || "");
                renderMathInChat(currentAiMessageDiv);
            } else {
                displayMessage(messageContent, 'AI');
            }

            // Salva il messaggio AI nel database
            await saveMessageToDatabase('assistant', messageContent);

            currentAiMessageDiv = null;
            accumulatedAiMarkdown = "";
            chatContainer.scrollTop = chatContainer.scrollHeight;

        } else {
            console.log("Unhandled message structure or non-AI message:", data);
        }
    });

    updateConnectionStatus(false, 'Connessione in corso...');
});
